var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopoverTooltip',[_c('p',[_vm._v(" O campo \""),_c('strong',[_vm._v("Nome completo")]),_vm._v("\" pode ter de "),_c('code',[_vm._v("3 a 48 caracteres")]),_vm._v(". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }